import { Injectable } from '@angular/core';

export const CONTEXT_USER_ID = 'userId';
export const CONTEXT_TENANT = 'tenant';
export const CONTEXT_AUTH_PROVIDER = 'authProvider';

@Injectable({
  providedIn: 'root',
})
export abstract class ToggleService {
  protected abstract updateContext(field: string, value: string): void;

  public abstract getVariant(
    toggleName: string,
    defaultValue: string | object
  ): string | object;
  public abstract isEnabled(toggleName: string): boolean;

  private isVariantObject(x: string | object): x is object {
    return typeof x === 'object';
  }

  private isVariantString(x: string | object): x is string {
    return typeof x === 'string';
  }

  public getVariantObject(toggleName: string, defaultValue: object): object {
    const variantValue = this.getVariant(toggleName, defaultValue);
    return this.isVariantObject(variantValue) ? variantValue : defaultValue;
  }

  public getVariantString(toggleName: string, defaultValue: string): string {
    const variantValue = this.getVariant(toggleName, defaultValue);
    return this.isVariantString(variantValue) ? variantValue : defaultValue;
  }

  public updateAuthProvider(authProvider: string): void {
    this.updateContext(CONTEXT_AUTH_PROVIDER, authProvider);
  }

  public updateTenant(tenant: string): void {
    this.updateContext(CONTEXT_TENANT, tenant);
  }
}
